export default __webpack_public_path__ + "197f8445834d8f61fe474e375bdcfd45.png";